import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { pageKey } from '@dashboard/lib/queryKeys';
import { pageHasRecurringBilling } from '@dashboard/services/getBillingModel';

import usePage from '@dashboard/hooks/usePage';

import PageEditView from '../../components/PageEditView';
import PageFilesForm from '../../components/PageFilesForm';
import { editorSection } from '../../pageEditTabs';

import Divider from '@dashboard/components/Divider';

import FilesForm from '../PageSettings/components/FilesForm';

import FormImageGalleryForm from './components/FormImageGalleryForm';
import FormDescriptionForm from './components/FormDescriptionForm';

export const getFormSections = ({ page, queryClient }) => {
  const context = { page };
  const section = path => editorSection('form', path, context);

  return [
    {
      ...section('/description'),
      component: (
        <FormDescriptionForm
          onChange={() => queryClient.invalidateQueries({ queryKey: pageKey(page._id) })}
        />
      ),
      description: 'Add text, images, FAQs, and more to describe your form.',
    },
    {
      ...section('/image-gallery'),
      component: <FormImageGalleryForm />,
      description: <>Add images to showcase your form.</>,
    },
    {
      ...section('/file-downloads'),
      component: (
        <>
          <PageFilesForm
            onChange={() => queryClient.invalidateQueries({ queryKey: pageKey(page._id) })}
          />

          {pageHasRecurringBilling(page) && (
            <>
              <Divider className="my-8" />
              <FilesForm />
            </>
          )}
        </>
      ),
      description: <>Add files to create a lead magnet.</>,
    },
  ].filter(tab => tab.isVisible(context));
};

const PageForm = () => {
  const { page } = usePage();
  const queryClient = useQueryClient();

  return <PageEditView tabs={getFormSections({ page, queryClient })} />;
};

export default PageForm;
